export default __webpack_public_path__ + "static/media/WStore_Icon_Aruba.c5f723f9.png";